import types from './types'

export const setRules = (rules) => ({
  type: types.SET_RULES,
  payload: rules
})